import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { transferAccountValidation } from './TransferAccount.validation';
import {
  TransferAccountDTO,
  useTransferAccountsOptionsQuery,
} from '../../api/useTransferAccountsOptionsQuery';
import { OptionType } from '../../../../CommonComponents/OPL/Select/BaseSelect/types';

export interface FormValues {
  selectedAccount: OptionType<TransferAccountDTO> | null;
}

export const useTransferAccount = () => {
  const queryResult = useTransferAccountsOptionsQuery();
  const selectOptions = useMemo(
    () =>
      queryResult.data?.map(account => ({
        value: { ...account },
        label: account.name,
        subLabel: account.institutionName,
      })) || [],
    [queryResult.data],
  );

  const formBag = useForm<FormValues>({
    defaultValues: {
      selectedAccount: null,
    },
    resolver: yupResolver(transferAccountValidation),
  });

  return {
    ...queryResult,
    data: {
      selectOptions,
      formBag,
    },
  };
};
